import React, { useState, useEffect } from 'react';
import settingsService from '../../../../../services/settings.service';
import { useEyeconxStore } from '../../../../../store/eyeconxStore';
import RecallHoursText from './RecallHoursText';
import RecallSettings from './RecallSettings';
import RecallSkeleton from './RecallSkeleton';
import ClinicSettingsSectionHeader from '../subparts/ClinicSettingsSectionHeader';

function RecallHours() {
    const [isLoading, setIsLoading] = useState(true);
    const [clinicHours, setClinicHours] = useState(null);
    const [recallSettings, setRecallSettings] = useState(null);
    const clinicId = useEyeconxStore((state) => state.user.clinicId);

    useEffect(() => {
        const fetchRecallData = async () => {
            setIsLoading(true);
            try {
                const [hoursRes, settingsRes] = await Promise.all([
                    settingsService.getRecallHours(clinicId),
                    settingsService.getRecallSettings(clinicId),
                ]);
                setClinicHours(hoursRes.data);
                setRecallSettings(settingsRes.data);
            } catch (err) {
                console.log('Error while loading recall settings', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchRecallData();
    }, [clinicId]);

    return (
        <>
            <ClinicSettingsSectionHeader
                title="Recall Settings"
                icon="bi-arrow-repeat"
                subtitle="Configure recall hours and patient recall preferences"
            />
            {isLoading ? (
                <RecallSkeleton />
            ) : (
                <div className="clinic-settings-stack">
                    <RecallHoursText clinicHours={clinicHours} />
                    <RecallSettings settings={recallSettings} />
                </div>
            )}
        </>
    );
}

export default RecallHours;
